import React, { useEffect, useState } from "react";
import cx from "../clients.module.css";
import { Modal } from "react-bootstrap";
import { httpAdmin } from "../../../Apis/commonApis";
import { ShowSwal } from "../../../utils/alertSwal";
import { formatDate } from "../../../utils/CommonFunctions";
import { fetchAdministrativeCarePlan } from "../../../redux-toolkit/reducer/clientCarePlanReducer";
import { useDispatch } from "react-redux";

const initialFormulation = {
  formulationDate: "",
  formulationLocation: "",
  performingProfessional: "",
  formulation: "",
  personCompleteRecord: "",
};

const FormulationModal = ({
  open,
  handleCloseAdmModal,
  openAdmModalDetails,
  CareplanAccess
}) => {
  const clientId = openAdmModalDetails?.commonData?.clientId;
  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState(initialFormulation);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (openAdmModalDetails?.isEdit && open) {
      // console.log(openAdmModalDetails, "openAdmModalDetails");
      const { _id, ...restData } = openAdmModalDetails?.editData;
      const splitDate = restData?.formulationDate?.split("T")[0];
      setFormValues((prev) => ({
        ...prev,
        ...restData,
        formulationDate: splitDate,
      }));
    }
  }, [openAdmModalDetails]);

  const handleChangeInputValues = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const createOrUpdateData = async () => {
    const finalData = {
      ...openAdmModalDetails?.commonData,
      ...formValues,
    };
    let apiEnd = "createAdministrativeCarePlan";
    if (openAdmModalDetails?.isEdit) {
      const id = openAdmModalDetails?.editData?._id;
      apiEnd = `updateAdministrativeCarePlan/${id}`;
    }
    const res = await httpAdmin(apiEnd, "post", finalData, null);
    if (res.status) {
      dispatch(fetchAdministrativeCarePlan(clientId));
    }
    ShowSwal(res.status, res.message);
    handleCloseAdmModal();
  };

  const handleDelete = async () => {
    const id = openAdmModalDetails?.editData?._id;
    setLoader(true);
    const res = await httpAdmin(
      `deleteAdministrativeCarePlan/${id}`,
      "delete",
      null,
      null
    );
    setLoader(false);
    ShowSwal(res.status, res.message);
    if (res.status) {
      dispatch(fetchAdministrativeCarePlan(clientId));
      handleCloseAdmModal();
    }
  };

  return (
    <Modal
      className="viewModal"
      show={open}
      size="lg"
      onHide={handleCloseAdmModal}
    >
      <div className="predefineTemplate">
        <h3>Formulation</h3>
        <div className="row mt-4 mb-5 align-items-center">
          <div className="col-md-6">
            <input
              title={`Formulation Record`}
              placeholder={`Formulation Record Name`}
              type="text"
              className="form-control"
              name="TemplateName"
              value={formValues.TemplateName}
              onChange={handleChangeInputValues}
            />{" "}
          </div>
          <div className="col-md-6">
            <ul className="menuListTop">
              <li>
                <button
                  className="btn"
                  onClick={createOrUpdateData}
                  disabled={CareplanAccess !== "full"}
                >
                  {openAdmModalDetails?.isEdit ? "Update" : "Save"}
                </button>
                {openAdmModalDetails?.isEdit && (
                  <button
                    disabled={loader || CareplanAccess !== "full"}
                    className="btn"
                    onClick={handleDelete}
                  >
                    Delete
                  </button>
                )}
              </li>
              <li>
                <button className="btn" onClick={handleCloseAdmModal}>
                  Close
                </button>
              </li>
            </ul>
          </div>
        </div>

        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <h6>
                Last Update Date:{" "}
                {formatDate(formValues.last_update_date) || "-"}
              </h6>
              <h6>Updated By: {formValues.updated_by || "-"}</h6>
            </div>
            {/* Questions and Answers Dynamic Form  */}

            <>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <div className={`${cx.safeBox} col-md-12`}>
                      <div
                        className={`col-12 position-relative ${cx.reactAutocomplete}`}
                      >
                        <label className="my-1">Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="formulationDate"
                          value={formValues.formulationDate}
                          onChange={handleChangeInputValues}
                        />
                      </div>
                      <div className="col-12">
                        <label className="mt-3">Location</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="The location where the formulation was made"
                          title="The location where the formulation was made"
                          name="formulationLocation"
                          value={formValues.formulationLocation}
                          onChange={handleChangeInputValues}
                        />
                      </div>
                      <div className="col-12">
                        <label className="mt-3">Performing professional</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="The professional who made the formulation"
                          title="The professional who made the formulation"
                          name="performingProfessional"
                          value={formValues.performingProfessional}
                          onChange={handleChangeInputValues}
                        />
                      </div>
                      <div className="col-12">
                        <label className="mt-3">Formulation</label>
                        <textarea
                          type="text"
                          className="form-control"
                          rows={4}
                          placeholder="An account, shared by a therapist and person, of the personal meaning and origins of a person’s difficulties. This is viewed in the context of multiple factors including relationships, social circumstances and life events and will indicate the most helpful way forward"
                          title="An account, shared by a therapist and person, of the personal meaning and origins of a person’s difficulties. This is viewed in the context of multiple factors including relationships, social circumstances and life events and will indicate the most helpful way forward"
                          name="formulation"
                          value={formValues.formulation}
                          onChange={handleChangeInputValues}
                        />
                      </div>
                      <div className="col-12">
                        <label className="mt-3">Person completing record</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Details of the person completing the record."
                          title="Details of the person completing the record."
                          name="personCompleteRecord"
                          value={formValues.personCompleteRecord}
                          onChange={handleChangeInputValues}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default FormulationModal;
